import request from '@/utils/request'

// 修改商户归集规则设定
export function updateCollectRule(id, data) {
  return request({
    url: `/app/updateCollectRule/${id}`,
    method: 'put',
    data,
  })
}

// 修改商户提现和归集地址设定
export function updateAddress(id, data) {
  return request({
    url: `/app/updateAddress/${id}`,
    method: 'put',
    data,
  })
}

// 取得红点泡泡数量
export function unallocatedAll() {
  return request({
    url: '/Unallocated/all',
    method: 'get',
  })
}

// 商户帐变列表 
export function listAppBalanceChangeDetails(params) {
  return request({
    url: '/app/listAppBalanceChangeDetails',
    method: 'get',
    params: params,
  })
}

// 线下商户下分 
export function appRecycle(data) {
  return request({
    url: '/app/recycle',
    method: 'post',
    data: data,
  })
}

// 线下商户上分
export function appTopUp(data) {
  return request({
    url: '/app/topUp',
    method: 'post',
    data: data,
  })
}

// 取得版本资讯列表
export function getVersionList(params) {
  return request({
    url: '/version/list',
    method: 'get',
    params: params,
  })
}

// 新增版本
export function addVersion(data) {
  return request({
    url: '/version/addVersion',
    method: 'post',
    data: data,
  })
}

// 更新版本
export function updateVersion(id, data) {
  return request({
    url: `/version/updateVersion/${id}`,
    method: 'post',
    data: data,
  })
}

// 获取所有注记类型
export function allFlagType() {
  return request({
    url: '/app/allFlagType',
    method: 'get',
  })
}

// 获取Okx参数
export function getOkxParam() {
  return request({
    url: '/app/okxParam',
    method: 'get',
  })
}


// WEBPACK FOOTER //
// ./src/api/app.js